"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubscription = void 0;
var tslib_1 = require("tslib");
var rxjs_1 = require("rxjs");
var react_1 = tslib_1.__importDefault(require("react"));
function useSubscription() {
    var subscription = react_1.default.useRef(new rxjs_1.Subscription()).current;
    react_1.default.useEffect(function () {
        return function cleanup() {
            subscription.unsubscribe();
        };
    }, []);
    return subscription;
}
exports.useSubscription = useSubscription;
//# sourceMappingURL=use-subscription.js.map